import React from 'react';

const OfferingSection = () => {
  return (
    <section className="overflow-hidden bg-white">
      <div className="max-w-[1440px] w-full mx-auto lg:px-[80px] md:px-[40px] px-[20px] lg:py-[80px] py-[40px]">

        <div className="flex flex-col lg:flex-row justify-between gap-[16px] md:gap-[40px] pb-[24px] md:pb-[40px]">
          <div className="max-w-[250px] w-full">
            <h2 className="text-[#01386A] font-[600] lg:text-[30px] text-[20px] font-sora leading-tight lg:leading-[40px]">
              Offering
            </h2>
          </div>

          <div className="max-w-[764px] w-full">
            <p className="text-[#49577A] text-[14px] lg:text-[16px] font-graphik leading-[24px] md:leading-[26px] font-[500]">
              Makers Lab is a space where ideas are welcomed, shaped, and turned into something real. We work with individuals, startups, and businesses to help bring concepts to life through thoughtful design, smart technology, and hands-on development. Whether it’s a first idea or a growing product, we support you at every step, from brainstorming and prototyping to building fully functional web, app, or IoT solutions. At Makers Lab, we believe in learning by doing, experimenting freely, and building with purpose. It’s not just about technology, it’s about solving real problems and creating things that truly make an impact in the real world.

            </p>
          </div>
        </div>

        <div className="mt-[32px] md:mt-[50px] border border-[#01386A45] lg:py-[44px] md:py-[30px] pt-[24px] lg:px-[160px] md:px-[40px] px-[20px] flex flex-col-reverse md:flex-row items-center justify-between overflow-hidden rounded-sm">
          <div className="w-full md:w-[55%] py-[24px] md:py-0 md:pr-[20px]">
            <h3 className="text-[#01386A] font-[600] text-[20px] lg:text-[30px] font-sora leading-tight mb-[12px] md:mb-[20px]">
              Mission
            </h3>

            <p className="text-[#49577A] text-[14px] lg:text-[16px] font-graphik leading-[24px] md:leading-[26px] font-[500] max-w-full md:max-w-[433px]">
              Makers Lab’s mission is to help people learn by doing, sparking creativity, collaboration and real-world problem solving through technology together.
            </p>
          </div>

          <div className="w-full md:w-[320px] lg:w-[387px] h-[200px] sm:h-[260px] md:h-auto shrink-0 overflow-hidden rounded-sm">
            <img
              src="/assets/lab/img2.png"
              alt="mission"
              className="w-full h-full object-cover"
            />
          </div>
        </div>

      </div>
    </section>
  );
};

export default OfferingSection;